import { render, staticRenderFns } from "./GrbData.vue?vue&type=template&id=72786268&scoped=true&"
import script from "./GrbData.vue?vue&type=script&lang=js&"
export * from "./GrbData.vue?vue&type=script&lang=js&"
import style0 from "./GrbData.vue?vue&type=style&index=0&id=72786268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72786268",
  null
  
)

export default component.exports